import type { ReactNode } from "react";
import { PageHeader } from "@/ui/organisms";
import { cn } from "@/utils/utils";

export interface TPageLayoutProps {
    title: string;
    description?: string;
    icon?: ReactNode;
    actions?: ReactNode;
    children: ReactNode;
    className?: string;
}

export function PageLayout({
    title,
    description,
    icon,
    actions,
    children,
    className,
}: TPageLayoutProps) {
    return (
        <div className={cn("space-y-6", className)}>
            <PageHeader title={title} description={description} icon={icon} actions={actions} />
            {children}
        </div>
    );
}
